import { map } from 'es-toolkit/compat';
import { type FC, useMemo } from 'react';
import { Form, FormGroup } from 'react-bootstrap';
import CreatableSelect from 'react-select/creatable';
import type { DropdownOptions } from '../../app.types';

export type ImageTagMultiselectProps = {
  dataCy: string;
  options?: DropdownOptions[];
  value: string[];
  onChange: (tags: string[]) => void;
  label: string;
  description?: string;
  isMulti?: boolean;
};

export const ImageTagMultiselect: FC<ImageTagMultiselectProps> = ({
  dataCy,
  options,
  onChange,
  label,
  description,
  isMulti = false,
  value,
}) => {
  const optionObjs = useMemo(
    () =>
      options?.map((opt) => ({
        label: opt.display,
        value: opt.value,
      })),
    [
      options,
    ],
  );
  const valueObjs = useMemo(
    () =>
      value.map((val) => ({
        label: val,
        value: val,
      })),
    [
      value,
    ],
  );

  return (
    <FormGroup controlId={dataCy}>
      <Form.Label>{label}</Form.Label>
      <CreatableSelect
        data-cy={dataCy}
        inputId={dataCy}
        isClearable
        isMulti={isMulti}
        noOptionsMessage={() => null}
        // biome-ignore lint/suspicious/noExplicitAny: legacy code
        onChange={(value: any) => {
          if (isMulti) {
            onChange(map(value, ({ label }) => label));
          } else if (value) {
            onChange([
              value.label,
            ]);
          } else {
            onChange([]);
          }
        }}
        options={optionObjs}
        placeholder={isMulti ? 'Enter tags...' : 'Enter tag...'}
        value={valueObjs}
      />
      {description && <Form.Text muted>{description}</Form.Text>}
    </FormGroup>
  );
};
